import * as React from 'react';

const germanyBlog = (<svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 16.0876C0 17.6602 1.27505 18.9353 2.84769 18.9353H22.7815C24.3541 18.9353 25.6292 17.6602 25.6292 16.0876V13.2399H0V16.0876Z" fill="#FFCD05"/>
<path d="M0 6.83258H25.6292V13.2399H0V6.83258Z" fill="#ED1F24"/>
<path d="M22.7815 0.425278H2.84769C1.27505 0.425278 0 1.70033 0 3.27297V6.83258H25.6292V3.27297C25.6292 1.70033 24.3541 0.425278 22.7815 0.425278Z" fill="#141414"/>
</svg>
);

export default germanyBlog;
